import script from "./yyyhao-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./yyyhao-profile.vue?vue&type=script&setup=true&lang=js"

import "./yyyhao-profile.vue?vue&type=style&index=0&id=f6b578a4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6b578a4"]])

export default __exports__